import 'react-toastify/dist/ReactToastify.css';
import './app.scss';
import 'app/config/dayjs';

import { Storage } from 'react-jhipster';
import React, { useEffect } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { IRootState, useAppDispatch } from 'app/config/store';
import ErrorBoundary from 'app/shared/error/error-boundary';
import AppRoutes from 'app/routes';
import { useSelector } from 'react-redux';
import { calculateScreenElementsHeight } from 'app/shared/util/screen-utils';
import { AUTH_TOKEN_KEY, loadedNotAuthenticated, successLogin } from 'app/shared/reducers/authentication';
import jwt from 'jwt-decode';
import { IUser, JWTUser } from 'app/shared/model/user.model';
import NiasChangeSubject from 'app/modules/nias-change-subject/nias-change-subject';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import Logout from 'app/modules/logout/logout';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LOCAL_STORAGE_KEYS } from "app/shared/util/local-storage-keys";
import IspuLocatorWrapper from "app/edozvola/cases/ispu/ispu-locator-wrapper";
import { DigitalSignatureModalProvider } from 'app/shared/digital-signature/DigitalSignatureModalContext';
import EsignResultWatcher from 'app/shared/util/EsignResultWatcher';

const baseHref = document.querySelector('base').getAttribute('href').replace(/\/$/, '');

export const queryClient = new QueryClient();

export const App = () => {
  const dispatch = useAppDispatch();
  const screenSizeState = useSelector((state: IRootState) => state.screenSize);

  useEffect(() => {
    if (Storage.local.get(AUTH_TOKEN_KEY)) {
      const token = Storage.local.get(AUTH_TOKEN_KEY);
      const user: JWTUser = jwt(token);
      const iuser: IUser = {
        id: user.idUser,
        firstName: user.firstName,
        lastName: user.lastName,
        authorities: user.authorities,
        userSelected: user.userSelected,
        szIsZastupanje: user.szIsZastupanje,
        szIpsRegistar: user.szIpsRegistar,
        szSubjectOfRepresentationSelected: user.szSubjectOfRepresentationSelected,
        mandate: user.mandate
      };
      dispatch(successLogin(iuser));
    } else {
      const pendingNiasNavbarFlag = localStorage.getItem(LOCAL_STORAGE_KEYS.PENDING_NIAS_NAVBAR);

      if (!pendingNiasNavbarFlag) {
        dispatch(loadedNotAuthenticated());
      } else {
        setTimeout(() => {
          localStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_NIAS_NAVBAR);
          dispatch(loadedNotAuthenticated());
        }, 500)
      }
    }
  }, []);

  useEffect(() => {
    calculateScreenElementsHeight();
  }, [screenSizeState.screenSize]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={baseHref}>
        <DigitalSignatureModalProvider>
          <div className="app-container">
            <ToastContainer position="top-left" className="toastify-container" toastClassName="toastify-toast" style={{ width: '400px' }} />
            <EsignResultWatcher />
            <ErrorBoundaryRoutes>
              <Route
                path="*"
                element={
                  <ErrorBoundary>
                    <AppRoutes />
                  </ErrorBoundary>
                }
              />
              <Route path="change-subject" element={<NiasChangeSubject />} />
              <Route path="logout" element={<Logout />} />
              <Route path="ispu-locator/:tabName/:entityId" element={<IspuLocatorWrapper />} />
            </ErrorBoundaryRoutes>
          </div>
        </DigitalSignatureModalProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
